"use strict";

var $ = require("jquery");
var uuid = require("./uuidMIT");

var CHANGE_PASSWORD_WIDGET = require("../html/ChangePassword.html");
var CHANGE_PASSWORD_COMMON = "";

require("../style/general.scss");
require("../style/uim-widget.scss");
var common = require("./common");
var templatesText = require("../json/TemplatesText.json");

var PWD_KEYUP_ABLE = true;
var CF_PWD_KEYUP_ABLE = true;


var OPTIONAL_FIELDS = [{
    selector: ".ie789-only",
    configKey: "showLabels"
}];

function UimChangePasswordWidget(params) {
    common.validateParams(params);
    this.isOlderIEVersion = navigator.appVersion.indexOf("MSIE 7.0") > -1 || navigator.appVersion.indexOf("MSIE 8.0") > -1
        || navigator.appVersion.indexOf("MSIE 9.0") > -1;

    this.successCallback = params.configuration.success || window.morningstar.uim.success;
    this.errorCallback = params.configuration.error || window.morningstar.uim.error;

    this.passwordPlaceholder = params.configuration.passwordPlaceholder;
    this.passwordConfirmationPlaceholder = params.configuration.passwordConfirmationPlaceholder;
    this.currentPasswordPlaceholder = params.configuration.currentPasswordPlaceholder;
    this.apigeeKey = params.configuration.apigeeKey;
    this.email = params.configuration.email;
    this.id = params.configuration.id;
    this.showLabels = this.isOlderIEVersion;
    this.environment = params.configuration.environment;
    this.baseUrl = common.API_ENVIRONMENTS[this.environment];

    this.element = params.element;
}

UimChangePasswordWidget.prototype.init = function () {
    var self = this,
        widgetText = templatesText["en"],
        handleBarTemplates = window.morningstar.uim.templates;

    // Set the template text
    CHANGE_PASSWORD_COMMON = handleBarTemplates.CommonSetPassword(widgetText.commonPassword);

    this.clearErrorMessages();
    this.element.append(CHANGE_PASSWORD_WIDGET);
    this.element.find("div#uim-uChangePassword-input").append(CHANGE_PASSWORD_COMMON);

    var passwordField = this.element.find("input#uim-uPassword-input");
    var confirmPasswordField = this.element.find("input#uim-uPasswordConfirmation-input");
    var currentPasswordField = this.element.find("input#uim-uCurrentPassword-input");
    var submit = this.element.find("input#uim-changePassword-submit");
    var close = this.element.find("input#uim-close-submit");
    var inputErrors = this.element.find("#input-errors");
    var confirmPasswordError = this.element.find("#confirm-password-error");

    // move showPasswordRequirements text to .uim-message.required error
    inputErrors.find(".uim-message.required").html(this.element.find("div#showPasswordRequirements").html());
    this.element.find("div#showPasswordRequirements").remove();

    this.fields = {
        password: passwordField,
        confirmPassword: confirmPasswordField,
        currentPassword: currentPasswordField
    };

    if (this.passwordPlaceholder) {
        passwordField[0].placeholder = this.passwordPlaceholder;
    }
    if (this.passwordConfirmationPlaceholder) {
        confirmPasswordField[0].placeholder = this.passwordConfirmationPlaceholder;
    }
    if (this.currentPasswordPlaceholder) {
        currentPasswordField[0].placeholder = this.currentPasswordPlaceholder;
    }
	
	passwordField.on("focus", function () {
		var isEmptyPWD = self.fields.password.val().length === 0;
		if(isEmptyPWD){
			PWD_KEYUP_ABLE = true;
			$("div#password-input-area").removeClass("error");
			common.hideElement(inputErrors.find(".uim-message.empty-password-input"));
			common.hideElement(inputErrors.find(".uim-message.required"));
			common.hideElement(inputErrors.find(".uim-message.maxlength"));
		}
		
    });
	
    passwordField.on("blur", function () {
		PWD_KEYUP_ABLE = common.validateRequiredField(passwordField,inputErrors,".uim-message.required");
        if(common.validateRequiredField(passwordField,inputErrors,".uim-message.required")) {
            PWD_KEYUP_ABLE = common.validatePassword(passwordField, inputErrors, self.email);
        } else {
            common.hideElement(inputErrors.find(".uim-message.maxlength"));
        }
        self.updateSubmitState();
    });

    passwordField.on("keyup", function () {
		if(!PWD_KEYUP_ABLE){
			var isEmptyPWD = self.fields.password.val().length === 0;
			if(common.validateRequiredField(passwordField,inputErrors,".uim-message.required")) {
				PWD_KEYUP_ABLE = common.validatePassword(passwordField, inputErrors, self.email);
			}else if(isEmptyPWD){
				passwordField.parent().removeClass("error");
				common.hideElement(inputErrors.find(".uim-message.empty-password-input"));
				common.hideElement(inputErrors.find(".uim-message.required"));
				common.hideElement(inputErrors.find(".uim-message.maxlength"));
				//this.clearErrorMessages();
				PWD_KEYUP_ABLE = true;	
			}else {
				common.hideElement(inputErrors.find(".uim-message.maxlength"));
			}			
			self.updateSubmitState();		
		}
    });

	confirmPasswordField.on("focus", function () {
		var isEmptyCFPWD = self.fields.confirmPassword.val().length === 0;
		if(isEmptyCFPWD){
			CF_PWD_KEYUP_ABLE = true;
			$("div#change-confirm-password-input-area").removeClass("error");
			common.hideElement(confirmPasswordError.find(".uim-message.password-empty-input"));
			common.hideElement(confirmPasswordError.find(".uim-message.password_match"));
		}
    });
	
    confirmPasswordField.on("blur", function () {
		CF_PWD_KEYUP_ABLE = common.validateRequiredField(confirmPasswordField,confirmPasswordError,".uim-message.password_match")
        if(common.validateRequiredField(confirmPasswordField,confirmPasswordError,".uim-message.password_match")) {
            CF_PWD_KEYUP_ABLE = common.validateConfirmPassword(passwordField, confirmPasswordField, confirmPasswordError);
        }
        self.updateSubmitState();
    });

    confirmPasswordField.on("keyup", function () {
		if(!CF_PWD_KEYUP_ABLE){
			var isEmptyCFPWD = self.fields.confirmPassword.val().length === 0;
			if(common.validateRequiredField(confirmPasswordField,confirmPasswordError,".uim-message.password_match")) {
				CF_PWD_KEYUP_ABLE = common.validateConfirmPassword(passwordField, confirmPasswordField, confirmPasswordError);
			}else if(isEmptyCFPWD){
				confirmPasswordField.parent().removeClass("error");
				common.hideElement(confirmPasswordError.find(".uim-message.password_match"));
				common.hideElement(confirmPasswordError.find(".uim-message.password-empty-input"));
				CF_PWD_KEYUP_ABLE = true;	
			}
			self.updateSubmitState();	
		}
    });

	
    currentPasswordField.on("keyup", function () {	
	self.updateSubmitState();
    });
	
    currentPasswordField.on('input',function(e){
	$('input#uim-changePassword-submit').removeAttr('disabled');
	passwordField.parent().removeClass("error");
	if(common.validateRequiredField(confirmPasswordField,confirmPasswordError,".uim-message.password_match")) {
            common.validateConfirmPassword(passwordField, confirmPasswordField, confirmPasswordError);
        }
		
	$("div#submit-errors").children().removeClass("show");
	$("div#submit-errors").children().addClass("hide");	       
		
    });
	
	
    submit.on("click enter", function (e) {
        e.preventDefault();
        self.submit({
            password: self.fields.password.val(),
            currentPassword: self.fields.currentPassword.val()
        });
    });

    close.on("click close", function (e) {
        e.preventDefault();
        parent.postMessage("close", "*");
    });

    for (var index = 0; index < OPTIONAL_FIELDS.length; index++) {
        var field = OPTIONAL_FIELDS[index];

        var showField = this[field.configKey];

        if (showField === false || showField === undefined) {
            common.hideElement(this.element.find(field.selector));
        }
    }
};

UimChangePasswordWidget.prototype.updateSubmitState = function() {
    if(this.allFilled() && !this.checkValidationErrors()) {
        $('#uim-changePassword-submit').removeAttr('disabled');
    } else {
        $('#uim-changePassword-submit').attr("disabled", true);
    }
};

UimChangePasswordWidget.prototype.showInputErrors = function (status) {
    var submitErrorsElement = this.element.find("#submit-errors");
    if (status === 400) {
        this.element.find("input#uim-uPassword-input").parent().addClass("error");
        this.element.find("input#uim-uPasswordConfirmation-input").parent().addClass("error");
        common.showElement(submitErrorsElement.find(".uim-message.authentication_error"));
    } else if (!!status) {
        common.showElement(submitErrorsElement.find(".uim-message.unknown_server_error"));
    }

    $('input#uim-changePassword-submit').attr("disabled", true);
};

UimChangePasswordWidget.prototype.clearErrorMessages = function () {
    var inputErrorsElement = this.element.find("#input-errors");
    var submitErrorsElement = this.element.find("#submit-errors");
    var confirmPasswordElement = this.element.find("#confirm-password-error");
    common.hideElement(submitErrorsElement.find(".uim-message.authentication_error"));
    common.hideElement(submitErrorsElement.find(".uim-message.unknown_server_error"));
    common.hideElement(inputErrorsElement.find(".uim-message.required"));
    common.hideElement(inputErrorsElement.find(".uim-message.maxlength"));
    common.hideElement(confirmPasswordElement.find(".uim-message.password_match"));
};

UimChangePasswordWidget.prototype.allFilled = function(){
    var filled = true;
    var isEmptyPassword = this.fields.password.val().length === 0;
    var isEmptyConfirmPassword = this.fields.confirmPassword.val().length === 0;
    var isEmptyCurrentPassword = this.fields.currentPassword.val().length === 0;

    if(isEmptyPassword || isEmptyConfirmPassword || isEmptyCurrentPassword){
        filled = false;
    }

    return filled;
};

UimChangePasswordWidget.prototype.checkValidationErrors = function() {

    var inputErrorsElement = this.element.find("#input-errors");
    var submitErrorsElement = this.element.find("#submit-errors");
    var confirmPasswordElement = this.element.find("#confirm-password-error");
    return (
        common.checkElement(submitErrorsElement.find(".uim-message.authentication_error")) ||
        common.checkElement(submitErrorsElement.find(".uim-message.unknown_server_error")) ||
        common.checkElement(inputErrorsElement.find(".uim-message.required")) ||
        common.checkElement(inputErrorsElement.find(".uim-message.maxlength")) ||
        common.checkElement(confirmPasswordElement.find(".uim-message.password_match")));
};

UimChangePasswordWidget.prototype.submit = function (params) {
    var self = this;

    $.ajax({
        method: "PATCH",
        url: this.baseUrl + "/users/" + this.id,
        xhrFields: {
            withCredentials: true
        },
        data: JSON.stringify({
            data : {
                type : "user" ,
                id : this.id ,
                attributes : {
                    password : params.password
                }
            },
            meta : {
                verificationPassword : params.currentPassword
            }
        }),
        headers : {
            ApiKey : this.apigeeKey,
            "X-API-RequestId": uuid()
        }
    }).success(function(data, status) {
        common.showElement(self.element.find("#changed"));
        common.hideElement(self.element.find("#notChanged"));
        self.successCallback(data, status);
    }).error(function (xhr, status, errorThrown) {
        self.showInputErrors(xhr.status);
        self.errorCallback(new Error("Problem in changing password"), xhr.status);
    });
};

module.exports = {
    createComponent: function (params) {
        var uimWidget = new UimChangePasswordWidget(params);
        uimWidget.init();

        return {
            setProperty: function () {},
            destroy: function () {
                params.element.children().remove();
            }
        };
    }
};



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/change-password.js
// module id = 16
// module chunks = 0